import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie9';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AppProvider } from './context';
import { ThemeProvider } from './contexts/ThemeContext';

import 'bootstrap/dist/css/bootstrap.css';
import 'assets/css/nucleo-icons.css';
import 'assets/css/black-dashboard-pro-react.css';
import 'assets/css/light-theme-overrides.css';
import 'react-notification-alert/dist/animate.css';

if (typeof window !== 'undefined') {
  // Always unregister any service worker (incl. in production) so deploys are
  // never masked by a stale cached app shell. The dashboard needs no offline SW.
  if ('serviceWorker' in navigator) {
    const staleWorkerCleanupKey = 'dashboard-sw-cleanup-v2';

    navigator.serviceWorker.getRegistrations().then(registrations => {
      if (!registrations || registrations.length === 0) {
        return;
      }

      Promise.all(registrations.map(registration => registration.unregister().catch(() => false))).then(() => {
        if (!window.sessionStorage.getItem(staleWorkerCleanupKey)) {
          window.sessionStorage.setItem(staleWorkerCleanupKey, 'true');
          window.location.reload();
        }
      });
    });
  }
}

const RootWrapper = process.env.NODE_ENV === 'production' ? React.StrictMode : React.Fragment;

ReactDOM.render(
  <RootWrapper>
    <AppProvider>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </AppProvider>
  </RootWrapper>,

  document.getElementById('root')
);
